// extracted by mini-css-extract-plugin
export default {"page_container":"Page_page_container__hJ7gb","bar":"Page_bar__8GHSu","navigation":"Page_navigation__nAznV","actions":"Page_actions__GFjva","children_box":"Page_children_box__WprOn"};